// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"763841dd","239":"a09337b9","453":"c33c26a3","732":"960e8921"}[chunkId] + ".chunk.js";
};